import "./component-library183.mjs";
import normalizeComponent from "./component-library82.mjs";
const _sfc_main = {
  name: "ContentToggle",
  props: {
    showContent: { type: Boolean }
  },
  methods: {
    /* eslint no-param-reassign: "error" */
    onBeforeEnter(el) {
      el.style.height = "0";
    },
    onEnter(el) {
      el.style.height = `${el.scrollHeight}px`;
    },
    onBeforeLeave(el) {
      el.style.height = `${el.scrollHeight}px`;
    },
    onLeave(el) {
      el.style.height = "0";
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "content-toggle" }, [_c("transition", { attrs: { "name": "fade" }, on: { "enter": _vm.onEnter, "leave": _vm.onLeave, "before-enter": _vm.onBeforeEnter, "before-leave": _vm.onBeforeLeave } }, [_vm.showContent ? _c("div", { attrs: { "data-testid": "content-toggle-open" } }, [_vm._t("default")], 2) : _vm._e()])], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "eb9cb6cb",
  null,
  null
);
const contentToggle = __component__.exports;
export {
  contentToggle as default
};
